import { AxiosResponse } from 'axios'
import { IEntityGST, IPaginatedEntityGST } from 'services/core/genericEntityGST'
import { RequestGST } from 'services/Instances'

export const GradacaoServices = () => {
  const path = 'Gradacao'

  const getAll = async (params: IGraduacaoMultasGetAllParams): Promise<AxiosResponse<IPaginatedEntityGST<IGraduacaoMultasGetAllResponse[]>>> =>
    await RequestGST.get(`${path}/Filter`, { params })

  const getGradacaoById = async ({ idGradacao }: { idGradacao: number }): Promise<AxiosResponse<IEntityGST<IGradacaoByIdResponse>>> =>
    await RequestGST.get(`${path}/GetById`, { params: { idGradacao } })

  const createGraduacaoMulta = async (body: ICreateGraduacaoMultaBody): Promise<AxiosResponse<IEntityGST<ICreateGraduacaoMultaResponse>>> =>
    await RequestGST.post(path, body)

  const updateGraduacaoMulta = async (body: IUpdateGraduacaoMultaBody): Promise<AxiosResponse<IEntityGST<IUpdateGraduacaoMultaResponse>>> =>
    await RequestGST.put(path, body)

  return {
    createGraduacaoMulta,
    getAll,
    getGradacaoById,
    updateGraduacaoMulta
  }
}

export const UfirServices = () => {
  const path = 'Ufir'
  const pathCreateUfir = 'Ufir/CadastrarUfir'

  const getAllHistoricoValorUnidadeUFIR = async (): Promise<AxiosResponse<IGraduacaoMultasGetAllHistoricoValorUnidadeUFIRResponse[]>> =>
    await RequestGST.get(`${path}`)

  const createNewValorUnidadeUFIR = async (body: IGraduacaoMultasCreateNewValorUnidadeUFIRBody): Promise<AxiosResponse<IEntityGST<IGraduacaoMultasGetAllHistoricoValorUnidadeUFIRResponse[]>>> =>
    await RequestGST.post(`${pathCreateUfir}`, body)

  return {
    createNewValorUnidadeUFIR,
    getAllHistoricoValorUnidadeUFIR
  }
}

export const GradacaoFiltersServices = () => {
  const pathAreasAtuacao = 'Enumeradores'
  const pathFaixa = 'Faixa'
  const pathInfracao = 'Infracao'

  const getAreasAtuacaoList = async (): Promise<AxiosResponse<IEntityGST<IAreasAtuacaoResponse[]>>> =>
    await RequestGST.get(`${pathAreasAtuacao}/GetAreaDeAtuacaoToDictionary`)

  const getFaixaFuncionariosList = async (): Promise<AxiosResponse<IEntityGST<IFaixaFuncionariosResponse[]>>> =>
    await RequestGST.get(`${pathFaixa}/GetFaixasToDictionary`)

  const getInfracoesList = async (): Promise<AxiosResponse<IEntityGST<IInfracoesResponse[]>>> =>
    await RequestGST.get(`${pathInfracao}/GetInfracaoToDictionary`)

  return {
    getAreasAtuacaoList,
    getFaixaFuncionariosList,
    getInfracoesList
  }
}

export interface IGradacaoByIdResponse {
  idGradacao: number
  infracaoId: number
  faixaId: number
  qtUfir: number
  flTipoMulta: string
}

export interface IUpdateGraduacaoMultaBody {
  idGradacao: number
  flTipoMulta: string
  faixaId: number
  infracaoId: number
  qtUfir: number
}

export interface IUpdateGraduacaoMultaResponse {
  txAreaAtuacao: string
  txNumeroFuncionarios: string
  txInfracao: string
  qtdUFIR: number
  idGradacaoDeMulta: number
}

export interface ICreateGraduacaoMultaBody {
  idGradacao: number
  flTipoMulta: string
  faixaId: number
  infracaoId: number
  qtUfir: number
}

export interface ICreateGraduacaoMultaResponse {
  txAreaAtuacao: string
  txNumeroFuncionarios: string
  txInfracao: string
  qtdUFIR: number
  idGradacaoDeMulta: number
}

export interface IGraduacaoMultasGetAllHistoricoValorUnidadeUFIRResponse {
  dataAtualizacao: string
  idUnidadeUFIR: number
  portaria: string
  vlUnidadeUFIR: number
}

export interface IGraduacaoMultasCreateNewValorUnidadeUFIRBody {
  vlUnidadeUFIR: number
  txPortaria: string
  dtCriacao: Date
}

export interface IGraduacaoMultasGetAllParams {
  idFaixa?: number
  idInfracao?: number
  txAreaAtuacao?: string
  qtdUFIR?: number
  txPesquisaGeral?: string
  pageNumber?: number
  pageSize?: number
}

export interface IGraduacaoMultasGetAllResponse {
  idGradacaoMulta: number
  txAreaAtuacao: string
  txNumeroFuncionarios: string
  txInfracao: string
  qtdUFIR: string
}

export interface IAreasAtuacaoResponse {
  codigoDeAreaDeAtuacao: string
  descricao: string
}
export interface IFaixaFuncionariosResponse {
  faixaId: string
  descricao: string
}
export interface IInfracoesResponse {
  idInfracao: string
  nuNivelInfracao: string
}
